import { c as _c } from "react/compiler-runtime";
import './sac-list-insert.scss';
import { cn } from '@sola/ark-core/utils/helpers.ts';
import { SacFilterProps } from '@sola/schema/lib/schema.ts';
import { getHeaderDisplayLevel } from '@sola/utils/assembly.ts';
import { FeatureBase } from '../../../molecules/feature-base/feature-base.tsx';
import { FeatureButtons } from '../../../molecules/feature-buttons/feature-buttons.tsx';
import { SacList } from '../../../molecules/sac-list/sac-list.tsx';
import { getBaseSizeProps } from '../../../utils/text-utils.tsx';
export const SacListInsert: React.FC<SacFilterProps> = t0 => {
  const $ = _c(40);
  let body;
  let primaryCTA;
  let sacList;
  let secondaryCTA;
  let subtitle;
  let t1;
  let tertiaryCTA;
  let title;
  if ($[0] !== t0) {
    ({
      seoLevel: t1,
      title,
      subtitle,
      body,
      primaryCTA,
      secondaryCTA,
      tertiaryCTA,
      ...sacList
    } = t0);
    $[0] = t0;
    $[1] = body;
    $[2] = primaryCTA;
    $[3] = sacList;
    $[4] = secondaryCTA;
    $[5] = subtitle;
    $[6] = t1;
    $[7] = tertiaryCTA;
    $[8] = title;
  } else {
    body = $[1];
    primaryCTA = $[2];
    sacList = $[3];
    secondaryCTA = $[4];
    subtitle = $[5];
    t1 = $[6];
    tertiaryCTA = $[7];
    title = $[8];
  }
  const seoLevel = t1 === undefined ? 2 : t1;
  const hasHeaderContent = !!title || !!body;
  let hasButtons;
  let t2;
  let t3;
  let t4;
  if ($[9] !== body || $[10] !== hasHeaderContent || $[11] !== primaryCTA || $[12] !== secondaryCTA || $[13] !== seoLevel || $[14] !== tertiaryCTA || $[15] !== title) {
    const headerDisplayLevel = getHeaderDisplayLevel(seoLevel);
    hasButtons = !!primaryCTA || !!secondaryCTA || !!tertiaryCTA;
    t4 = "SacListInsert component";
    t2 = "container flex flex-col gap-comfy-xl";
    t3 = hasHeaderContent && <div className={cn("w-full mx-auto")}><FeatureBase {...getBaseSizeProps(headerDisplayLevel)} seoLevel={seoLevel} {...{
        title,
        body
      }} variant="centered" variantResponsive={true} inline={true} /></div>;
    $[9] = body;
    $[10] = hasHeaderContent;
    $[11] = primaryCTA;
    $[12] = secondaryCTA;
    $[13] = seoLevel;
    $[14] = tertiaryCTA;
    $[15] = title;
    $[16] = hasButtons;
    $[17] = t2;
    $[18] = t3;
    $[19] = t4;
  } else {
    hasButtons = $[16];
    t2 = $[17];
    t3 = $[18];
    t4 = $[19];
  }
  let t5;
  if ($[20] !== sacList) {
    t5 = <SacList {...sacList} columnsMd="3" />;
    $[20] = sacList;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  let t6;
  if ($[22] !== subtitle) {
    t6 = subtitle && <FeatureBase body={<p>{subtitle}</p>} bodySize="sm" className="max-w-md" inline={true} />;
    $[22] = subtitle;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  let t7;
  if ($[24] !== hasButtons || $[25] !== primaryCTA || $[26] !== secondaryCTA || $[27] !== tertiaryCTA) {
    t7 = hasButtons && <FeatureButtons {...{
      primaryCTA,
      secondaryCTA,
      tertiaryCTA
    }} variant="noWrap" />;
    $[24] = hasButtons;
    $[25] = primaryCTA;
    $[26] = secondaryCTA;
    $[27] = tertiaryCTA;
    $[28] = t7;
  } else {
    t7 = $[28];
  }
  let t8;
  if ($[29] !== t6 || $[30] !== t7) {
    t8 = <div className="flex flex-col md:flex-row items-center md:justify-between gap-comfy-lg">{t6}{t7}</div>;
    $[29] = t6;
    $[30] = t7;
    $[31] = t8;
  } else {
    t8 = $[31];
  }
  let t9;
  if ($[32] !== t2 || $[33] !== t3 || $[34] !== t5 || $[35] !== t8) {
    t9 = <div className={t2}>{t3}{t5}{t8}</div>;
    $[32] = t2;
    $[33] = t3;
    $[34] = t5;
    $[35] = t8;
    $[36] = t9;
  } else {
    t9 = $[36];
  }
  let t10;
  if ($[37] !== t4 || $[38] !== t9) {
    t10 = <section className={t4}>{t9}</section>;
    $[37] = t4;
    $[38] = t9;
    $[39] = t10;
  } else {
    t10 = $[39];
  }
  return t10;
};